<template>
    <el-container>
        <el-form :model="formOrgInfo" label-position="right" :label-width="formLabelWidth" ref="formOrgInfo" :rules="rules" style="margin-bottom:10px;">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.NAME')" prop="sName">
                        <td-input v-model="formOrgInfo.sName" maxlength="100"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.NUMBER')" prop="sCode">
                        <td-input v-model="formOrgInfo.sCode" maxlength="100"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.PARENT_ORG')" prop="parentOrgName">
                        <td-input v-model="formOrgInfo.sParentName" :disabled="true"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.TYPE')" prop="sTypeName">
                        <td-select
                            :options="typeOptions"
                            keys="id"
                            text="name"
                            :placeholder="$t('common.PLEASE_SELECT')"
                            v-model="formOrgInfo.iType"
                            @change="changeSelect"
                            :clearable="false"
                            v-bind:disabled="!isAddData"
                        ></td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <td-dynamic ref="tdDynamic" :groupFlg="extendGroupFlg" :labelWidth="formLabelWidth" v-model="extendElementValue"></td-dynamic>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item :label="$t('common.DESCRIPTION')" prop="description">
                        <td-input type="textarea" :rows="2" v-model="formOrgInfo.description" width="96%" maxlength="200"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </el-container>
</template>
<script>
import orgApi from './../assets/api.js';
export default {
    props: {
        // 传入页面的数据
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        // 下拉框数据
        tabOptions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //是否是添加数据
        isAddData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        /* 当前选中的组织类型 */
        selectType: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        //表单提交前触发的方法
        beforeSubmitForm: Function,
        //表单验证失败触发的方法
        validateSubmitFormFail: Function,
        //类型下拉框触发的方法
        typeSelectChange: Function
    },

    mounted() {
        this.typeOptions = this.tabOptions;
        if (this.selectType !== null && this.selectType !== '' && this.selectType !== undefined) {
            this.formOrgInfo.iType = Number(this.selectType);
        }
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            this.initAddData();
        }
        //处理编号规则(区域国标化)
        this.dealAreaRule(this.formOrgInfo.iType);
    },

    // 定义变量
    data() {
        let validateCode = (rule, value, callback) => {
            let orgId = '';
            if (!this.isAddData) {
                orgId = this.editItem.orgId;
            }
            let param = {
                sOrgId: orgId,
                sCode: value
            };
            orgApi.checkCodeRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('orgApi.checkCodeRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgCommon.SCODE_HAS_EXIST_PLEASE_INPUT'));
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            // 表单信息
            formOrgInfo: {
                sOrgId: '',
                sName: '',
                iType: 0,
                typeName: '',
                sParentName: '',
                sParentId: '',
                sCode: '',
                description: ''
            },
            // 组织类型下拉框数据
            typeOptions: [],
            extendElementValue: {},
            customRules: null,
            formLabelWidth: '100px',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sCode: [
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ]
            },
            codeRules: [
                // eslint-disable-next-line standard/object-curly-even-spacing
                { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' },
                { validator: validateCode, trigger: 'blur' }
            ],
            areaCodeRules: [{ validator: validateCode, trigger: 'blur' }],
            areaCodePatternRule: { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' }
        };
    },
    // 定义并实现方法体
    methods: {
        // 下拉框change事件
        changeSelect(param) {
            this.dealAreaRule(param);
            // 判断是否需要切换显示的tab页签
            this.$emit('typeSelectChange', param);
        },
        //处理编号规则(区域国标化)
        dealAreaRule(orgTypeId) {
            //查询字典表，是否配置国标
            if (this.customRules == null) {
                let tag = {
                    sTag: 'system_national_standard_area_code_rule'
                };
                orgApi.getDictValuesByType(JSON.stringify(tag), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        return;
                    }
                    let patternFlag = false;
                    let result = response.data.content;
                    if (result && result.length > 0) {
                        result.forEach(element => {
                            // 必填校验
                            if (element.sId == 'system_national_standard_area_code_rule_required') {
                                if (element.sCode && element.sCode == 'true') {
                                    let required = {};
                                    required.required = element.sCode;
                                    required.message = element.sValue;
                                    this.areaCodeRules.push(required);
                                }
                            }
                            // 正则校验
                            if (element.sId == 'system_national_standard_area_code_rule_pattern') {
                                if (!this.$util.isEmpty(element.sCode)) {
                                    patternFlag = true;
                                    let pattern = {};
                                    pattern.pattern = element.sCode;
                                    pattern.message = element.sValue;
                                    this.areaCodeRules.push(pattern);
                                }
                            }
                        });
                        this.customRules = true;
                        this.changeCodeRule(orgTypeId);
                    } else {
                        this.customRules = false;
                    }
                    if (!patternFlag) {
                        this.areaCodeRules.push(this.areaCodePatternRule);
                    }
                });
            } else if (this.customRules) {
                this.changeCodeRule(orgTypeId);
            }
        },
        changeCodeRule(orgTypeId) {
            //若为区域
            if (window.pangu.common.orgType.ORG_AREA == orgTypeId) {
                if (this.rules.sCode != this.areaCodeRules) {
                    this.rules.sCode = this.areaCodeRules;
                }
            } else {
                this.rules.sCode = this.codeRules;
            }
            this.$refs.formOrgInfo.validateField('sCode');
        },
        // 初始化编辑数据
        initEditData() {
            this.formOrgInfo.sOrgId = this.editItem.orgId;
            this.formOrgInfo.sName = this.editItem.orgName;
            this.formOrgInfo.iType = this.editItem.iType;
            this.formOrgInfo.typeName = this.editItem.typeName;
            this.formOrgInfo.sParentId = this.editItem.parentOrgId;
            this.formOrgInfo.sParentName = this.editItem.parentOrgName;
            this.formOrgInfo.description = this.editItem.sDescription;
            this.formOrgInfo.sCode = this.editItem.sCode;
            if (this.editItem.sExtendInfo) {
                try {
                    this.extendElementValue = JSON.parse(this.editItem.sExtendInfo.replace(/\\/g, ''));
                } catch (e) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('pgError.ERROR_MESSAGE_JSON') });
                }
            }
        },

        // 初始化添加数据
        initAddData() {
            this.formOrgInfo.sParentId = this.editItem.parentOrgId;
            this.formOrgInfo.sParentName = this.editItem.parentOrgName;
        },

        // 提交数据
        submitForm() {
            this.$refs.formOrgInfo.validate(valid => {
                //默认扩展校验通过
                let dynamicCheck = true;
                if (this.extendGroupFlg) {
                    this.$refs.tdDynamic.$refs.dynamicForm.validate(validDynamic => {
                        dynamicCheck = validDynamic;
                    });
                }
                if (valid && dynamicCheck) {
                    let extendInfos = {};
                    if (this.extendGroupFlg) {
                        extendInfos = this.$refs.tdDynamic.getfromInfo();
                    }
                    let content = {
                        sName: this.formOrgInfo.sName,
                        iType: this.formOrgInfo.iType === '' ? '0' : this.formOrgInfo.iType,
                        sParentId: this.formOrgInfo.sParentId,
                        sDescription: this.formOrgInfo.description,
                        sCode: this.formOrgInfo.sCode,
                        sExtendInfo: extendInfos
                    };
                    if (!this.isAddData) {
                        content.sOrgId = this.formOrgInfo.sOrgId;
                    }
                    this.$emit('beforeSubmitForm', content);
                } else {
                    this.$emit('validateSubmitFormFail');
                }
            });
        },

        // 取消
        cancel() {
            this.orgDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
            this.$refs.formOrgInfo.resetFields(); // 重置表单数据
            this.editItem = null;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
